"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMarkPrice = void 0;
const amm_1 = require("./amm");
/**
 * Calculates market mark price
 *
 * @param market
 * @return markPrice : Precision MARK_PRICE_PRECISION
 */
function calculateMarkPrice(market) {
    return amm_1.calculatePrice(market.amm.baseAssetReserve, market.amm.quoteAssetReserve, market.amm.pegMultiplier);
}
exports.calculateMarkPrice = calculateMarkPrice;
